var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),(!_vm.loading)?_c('user-edit',{attrs:{"user":_vm.user},on:{"reload":_vm.load}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }